module.exports = __webpack_public_path__ + "static/media/sub-card-label-7-over.8c880f9b.svg";